"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* The chat cards' statuses, by chat and code, for web and mobile. The codes
 * asked in one tick go out as one GetFormStatuses call per chat (100 codes at
 * most per call). A code the server leaves out is stored as null: the message
 * then reads as plain text. A "FormChanged" notice rereads its code, and a
 * socket reconnect has every card on screen read its status again, since
 * notices sent while the socket was down are lost. */
var _react = require('react');

var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);

var _api = require('./api');
var _events = require('./events');


const BATCH = 100
const RECONNECTED = 'SERVER_ACK_SOCKET_CONNECTED'



const keyOf = (conversationKey, code) => `${conversationKey}:${code}`

const statuses = new Map()
// What was asked since the last reconnect, by chat and code.
const asked = new Map()
const queued = new Map()
const listeners = new Set()
let generation = 0
let flushTimer = null
let stopListening = null

const notify = () => listeners.forEach(listener => listener())
const subscribe = (listener) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
const getGeneration = () => generation

const flush = () => {
  flushTimer = null
  const batches = [...queued.values()]
  queued.clear()
  batches.forEach(({ orgKey, conversationKey, codes }) => {
    const all = [...codes]
    for (let at = 0; at < all.length; at += BATCH) {
      const chunk = all.slice(at, at + BATCH)
      _api.getFormStatuses.call(void 0, { OrgKey: orgKey, ConversationKey: conversationKey, Codes: chunk })
        .then(({ Statuses }) => {
          chunk.forEach(code => statuses.set(keyOf(conversationKey, code), null))
          ;(Statuses || []).forEach(status => statuses.set(keyOf(conversationKey, status.Code), status))
          notify()
        })
        // A failed read is asked again by the next card that mounts.
        .catch(() => chunk.forEach(code => asked.delete(keyOf(conversationKey, code))))
    }
  })
}

const queue = ({ orgKey, conversationKey, code }) => {
  const batch = _nullishCoalesce(queued.get(conversationKey), () => ( { orgKey, conversationKey, codes: new Set() }))
  batch.codes.add(code)
  queued.set(conversationKey, batch)
  flushTimer ??= setTimeout(flush, 0)
}

const onReconnect = () => {
  asked.clear()
  generation += 1
  notify()
}

const listen = () => {
  if (stopListening) return
  const stopNotices = _events.onFormChanged.call(void 0, notice => {
    if (!notice.Code) return
    asked.forEach(ask => { if (ask.code === notice.Code) queue(ask) })
  })
  _bus2.default.on(RECONNECTED, onReconnect)
  stopListening = () => {
    stopNotices()
    _bus2.default.off(RECONNECTED, onReconnect)
  }
}

/* Asks for these codes' statuses in a chat; codes already asked do nothing. */
const wantFormStatuses = (orgKey, conversationKey, codes) => {
  listen()
  codes.forEach(code => {
    const key = keyOf(conversationKey, code)
    if (asked.has(key)) return
    const ask = { orgKey, conversationKey, code }
    asked.set(key, ask)
    queue(ask)
  })
}

/* One card's status: undefined while it loads, null when the server has none
 * for this chat. With no orgKey (Forms off) it asks nothing. `chatCodes`, the
 * other form codes in the chat's loaded messages, go out in the same call. */
 const useFormStatus = (
  orgKey,
  conversationKey,
  code,
  chatCodes,
) => {
  const gen = _react.useSyncExternalStore.call(void 0, subscribe, getGeneration)
  _react.useEffect.call(void 0, () => {
    if (!orgKey || !code) return
    const others = _nullishCoalesce(chatCodes, () => ( []))
    wantFormStatuses(orgKey, conversationKey, others.includes(code) ? others : [code, ...others])
  }, [orgKey, conversationKey, code, chatCodes, gen])
  return _react.useSyncExternalStore.call(void 0, subscribe, () => (orgKey && code ? statuses.get(keyOf(conversationKey, code)) : undefined))
}; exports.useFormStatus = useFormStatus

/* For tests: forget everything. */
 const resetFormStatuses = () => {
  statuses.clear()
  asked.clear()
  queued.clear()
  if (flushTimer) clearTimeout(flushTimer)
  flushTimer = null
  _optionalChain([stopListening, 'optionalCall', _ => _()])
  stopListening = null
}; exports.resetFormStatuses = resetFormStatuses
